<template>
	<div class="relative h-full">
		<div
			class="bg-white rounded-3xl flex h-full flex-col px-[var(--space-8)] py-[var(--space-11)] justify-center shadow-xl"
			:class="[
				isScreen ? 'full-screen' : 'not-full-screen'
			]"
		>
			<div class="flex flex-row items-center gap-4 pb-2 -mt-4">
				<img
					:src="image"
					alt="category-card"
					class="w-20 h-full object-cover"
					width="110"
					height="110"
				/>
				<h2 class="text-2xl font-bold text-slate-950">{{ title }}</h2>
			</div>

	
			<span 
			v-if="!hide_label"
			class="text-slate-700 border-t border-slate-100  py-[20px] capitalize">
				{{ getTranslations("choose category") }}:
			</span>
			<span v-else class="text-slate-700 border-t border-slate-100  pt-3 pb-4 capitalize"></span>
			<div class="w-full flex flex-col gap-[var(--space-3)]">
				<ArrowButton
					v-for="sector in this.sectors"
					:key="sector.id"
					:title="sector.title"
					:icon="sector.icon"
					:click_handler="sector.is_disabled ? null : () => selectSector(sector)"
					:disabled="sector.is_disabled"
				>
		
				</ArrowButton>
			</div>
		</div>
	</div>
</template>

<script lang="js" src="./CategoryCard.js"></script>
